export enum ElevenProof {
  BSN = "bsn",
}
